import { Component, effect } from "@angular/core";
import { DirectSessionLogicService } from "../shared/direct-session-logic.service";
import { ConfigData } from "../shared/models/config-data.model";

import { environment } from "../../environments/environment";
import { ItemFormat } from "../shared/models/itemFormat.model";
import { CustomerFormat } from "../shared/models/customerFormat.model";

@Component({
    selector: 'app-confirmation-page',
    template:`
        <div id="customer-container" class="recipt-container card p-4 mt-4 mb-4">
            <div class="">
                <div class="recipt-header">Welcome to {{this.companyName}}!</div>
                <div class="thank-you">
                    <img src="assets/Icons/check-circle.svg" alt="checkmark" class="thank-you-icon">
                    <div class="thank-you-text">Thank you for your payment!</div>
                </div>
                <p>
                    A payment confirmation email and a member enrollment email has been sent to {{this.emailProxy}} with instructions on activating your protection. <br>
                </p>  
                <p>
                    Payment details can be found below.
                </p>

                <hr>

                <div class="customer-infoThank card p-4 mt-4 mb-4">
                    <div class="mb-4">
                        <label class="d-block">Account Holder</label>
                        <label class="d-block fw-bold">
                            <span id="custName">{{this.customerName}}</span>

                        </label>
                    </div>
                    <div class="mb-4">
                        <label class="d-block">Reference Number</label>
                        <label class="d-block fw-bold">
                            <span id="pRef">{{this.purchaseRef}}</span>

                        </label>
                    </div>
                    <div class="mb-4">
                        <label class="d-block">Plan</label>
                        <label class="d-block fw-bold">
                            <span id="planName">{{this.planName}}</span>
                        </label>
                    </div>
                    <div class="mb-4">
                        <label class="d-block">Child Protection (optional)</label>
                        <label class="d-block fw-bold">
                            <span id="childrenResponse">{{this.childrenResponse}}</span>
                        </label>
                    </div>
                    <div class="mb-4">
                        <label class="d-block">Payment Amount</label>
                        <label class="d-block fw-bold">
                            <span id="paymentAmount">\${{this.paymentAmount}}</span>
                        </label>
                    </div>
                    <div class="mb-4">
                        <label class="d-block">Payment Method</label>
                        <label class="d-block fw-bold">
                            <span id="paymentMethod">{{this.paymentMethod}}</span>
                        </label>
                    </div>
                    <div class="mb-4">
                        <label class="d-block">Payment Date</label>
                        <label class="d-block fw-bold">
                            <span id="paymentDate">{{paymentDate}}</span>
                        </label>
                    </div>

                    <hr>
                    <div class="my-2">
                        <div>
                            Recurring Payments will be billed automatically to the card ending with {{this.customer.ccLast4}}. 
                            If you need to make changes to your payment, please call {{this.companyName}} Customer Service at
                            <a href="tel:{{this.customerServicePhoneNumber}}">{{this.customerServicePhoneDisplay}}</a>
                        </div>
                    </div>

                    <hr>
                    <div class="text-center" >
                        <img src="assets/Icons/EXP-data-provided-by.svg" alt="Experian Logo" 
                            class="experian-icon" />

                    </div>

                </div>
            </div>
        </div>
    `,
    styleUrls: ['./confirmation-page.component.scss'],
    standalone: true,

})

export class ContractCompletionPage{

    selections: ItemFormat[] = [];
    customer: CustomerFormat = {} as CustomerFormat;

    childrenResponse: string = '';
    emailProxy: string = '';
    companyName: string = '';
    customerServicePhoneNumber: string = '';
    customerServicePhoneDisplay: string = '';
    

    customerName: string = '';
    planName: string = '';
    paymentAmount: number = 0;
    paymentMethod: string = '';

    memeberID: string = '';
    purchaseRef: string = '';


    paymentDate: string = '';

    constructor(
        public directSessionLogic: DirectSessionLogicService,
    ){
        this.initResults();
        this.initConfig();

        // should be done on previous step by call and filled into session after payment success api call
        this.paymentDate = new Date().toLocaleDateString('en-US');  

        if(this.directSessionLogic.selectedPlanSignalValue === undefined) {
            this.directSessionLogic.escapeToTopLevelSignal()
        }

        effect(() => {
            this.customer = this.directSessionLogic.customerSignal();
            this.customerName = this.customer.firstName + ' ' + this.customer.lastName;
            this.paymentMethod = this.customer.cardType +' - **** **** **** ' + this.customer.ccLast4;
            
        });

        effect(() => {
            this.planName = this.directSessionLogic.planSelectedSignal().name ?? "";
        });

        effect(() => {
            this.purchaseRef = this.directSessionLogic.trimmedSessionSignal().purchaseRef;
            this.paymentAmount = this.directSessionLogic.trimmedSessionSignal().totalCost;
        });

        this.memeberID = 'Didn\'t get policy from forte yet.';
    }

    async initResults() {
        this.childPlanSpecificCheck();
        this.emailProxyBuilder();
    }

    async initConfig() {
        this.companyName = environment.CompanyInfo.CompanyName;

        this.customerServicePhoneDisplay = environment.CompanyInfo.CustomerServicePhoneDisplay;
        this.customerServicePhoneNumber = "+" + this.customerServicePhoneDisplay.replace(/\D/g,"");
    }


    childPlanSpecificCheck() {
        if(this.selections){
            if(this.selections.length > 0 
                // && this.session.selections[0].itemFeatureRef === 'children'
                ) {

                this.childrenResponse = "Yes";
            }else{
                this.childrenResponse = "No";
            }
        }else{
            this.childrenResponse = "No";
        }
    }

    emailProxyBuilder(){
        let customer = this.directSessionLogic.customerSignal();
        let emailPrefix = customer.email.split('@')[0];
        let emailSuffix = customer.email.split('@')[1];

        this.emailProxy = emailPrefix.slice(0, 2) + '****' + emailPrefix.slice(-2) + "@" + emailSuffix;
    }
}